import React, { ReactElement } from 'react';
import { RouteProps } from 'react-router-dom';
import Footer from 'components/footer/footer';
import Header from 'components/header/header';
import { Helmet } from 'react-helmet-async';

interface MainLayoutProps extends RouteProps {
  theme?: 'white' | 'blue' | 'charcoal';
  position?: 'absolute' | 'relative';
  hostSlug?: string;
  hostUrl?: string | null;
  logoUrl?: string;
  color?: string;
  hideHeader?: boolean;
  hideFooter?: boolean;
}

export default function MainLayout(props: MainLayoutProps): ReactElement {
  const {
    color,
    hideFooter,
    hideHeader,
    hostSlug,
    hostUrl,
    logoUrl,
    theme,
    position,
  } = props;
  return (
    <div className='main-layout'>
      <Helmet>
        <title>BestCamp</title>
        <meta name='description' content='Best way to stay!' />
        <meta property='og:image' content='/favicon.ico' />
        <link rel='icon' href='/favicon.ico' />
      </Helmet>
      {/** Here we should check only for undefined so that BestCamp header won't be visible before camp data has been
       * fetched from the server. Otherwise BestCamp header will flash before actual camps hostUrl becomes available. */}
      {hostUrl !== undefined && !hideHeader && (
        <Header
          theme={theme}
          position={position}
          hostSlug={hostSlug}
          hostUrl={hostUrl}
          logoUrl={logoUrl}
          color={color}
        />
      )}

      <div className='layout-content'>{props.children}</div>
      {!hideFooter && <Footer />}
    </div>
  );
}
